import ExperimentProviderContext from '@carvana/experiment/ExperimentProviderContext';
import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect } from 'react';

const useSendDDExperiments = () => {
  const { experiments } = useContext(ExperimentProviderContext);

  useEffect(() => {
    const experimentsWithBucket = Object.keys(experiments).reduce(
      (accum, key) => {
        accum[key] = experiments[key].assignedBucket;

        return accum;
      },
      {}
    );

    datadogRum.addRumGlobalContext('experiments', experimentsWithBucket);
  }, [experiments]);
};

export default useSendDDExperiments;
